import type { Page, PlottingContext } from "@pdfking/renderer"

import type { SinglePagePdf } from "../../files/cached/SinglePagePdf"
import type { TaskBase } from "../base/TaskBase"
import type { TaskName } from "../TaskName"

export type FilePlottingContext = Partial<
  {
    readonly file_map: Record<string, SinglePagePdf>
  } & Omit<PlottingContext, "file_map">
>

export type TaskPlotOptions = {
  readonly enum: TaskName.TASK_PLOT
  readonly page: Page
  readonly context: FilePlottingContext
} & TaskBase
